"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGoal = void 0;
var IGoal;
(function (IGoal) {
    IGoal["LoseWeight"] = "Lose Weight";
    IGoal["MuscleTone"] = "Muscle Tone";
    IGoal["Performance"] = "Performance";
    IGoal["HealthAndWellness"] = "Health & Wellness";
})(IGoal || (exports.IGoal = IGoal = {}));
//# sourceMappingURL=goal.js.map